import { arrayOf, object, string } from "prop-types"
import Form from "./form"

const FormsList = ({ forms = [], questionsIndexPath }) => {
  const handleRowClick = () => {
    const attendeeQuestionsPath = questionsIndexPath

    window.location.href = attendeeQuestionsPath
  }

  return (
    <div className="scrollable-table">
      <table className="table">
        <thead>
          <tr>
            <th>Form name</th>
            <th>Type</th>
            <th>Collected for</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            className="row__clickable"
            role="button"
            tabIndex="0"
            style={{ verticalAlign: "top" }}
            onClick={handleRowClick}
          >
            <td>Attendee information form</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          {forms.map((form, index) => {
            return <Form key={index} form={form} />
          })}
        </tbody>
      </table>
    </div>
  )
}

FormsList.propTypes = {
  forms: arrayOf(object),
  questionsIndexPath: string.isRequired
}

export default FormsList
